var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.72 14",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45,14a3.28,3.28,0,0,0,3.27-2.13l-.78-.63C8.27,12.5,7.65,13,6.47,13s-2.25-.63-3.58-.76A7,7,0,0,0,3.75,9a7,7,0,0,0-.21-1.69h4l.23-1H3.29a10.56,10.56,0,0,1-.44-2.61A2.51,2.51,0,0,1,5.52,1,3.76,3.76,0,0,1,8.77,2.78l.74-.65A4.35,4.35,0,0,0,5.52,0,3.5,3.5,0,0,0,1.77,3.69a11.07,11.07,0,0,0,.38,2.59H.76l-.21,1H2.4A7,7,0,0,1,2.62,8.9a8.64,8.64,0,0,1-.85,3.33,6.14,6.14,0,0,0-1.5.42L0,13.81a4.68,4.68,0,0,1,2.23-.61C3.61,13.2,4.91,14,6.45,14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPound);
export default __webpack_public_path__ + "static/media/pound.e1166d9f362877089d348dde4c807d92.svg";
export { ForwardRef as ReactComponent };